var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "primary", attrs: { id: "divMenu" } }, [
    _c("span", { staticClass: "title" }, [_vm._v(" IDBStudio ")]),
    _vm._v(" "),
    _c("ul", { staticClass: "right-menu" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("li", { staticClass: "seperator" }, [_vm._v("|")]),
      _vm._v(" "),
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              title: "fork on github",
              target: "_blank",
              href: "https://github.com/ujjwalguptaofficial/idbstudio/fork"
            }
          },
          [
            _c(
              "svg",
              {
                staticClass: "octicon octicon-repo-forked",
                staticStyle: { fill: "white", "vertical-align": "sub" },
                attrs: {
                  version: "1.1",
                  width: "10",
                  height: "18",
                  viewBox: "0 0 10 16",
                  "aria-hidden": "true"
                }
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    d:
                      "M8 1a1.993 1.993 0 0 0-1 3.72V6L5 8 3 6V4.72A1.993 1.993 0 0 0 2 1a1.993 1.993 0 0 0-1 3.72V6.5l3 3v1.78A1.993 1.993 0 0 0 5 15a1.993 1.993 0 0 0 1-3.72V9.5l3-3V4.72A1.993 1.993 0 0 0 8 1zM2 4.2C1.34 4.2.8 3.65.8 3c0-.65.55-1.2 1.2-1.2.65 0 1.2.55 1.2 1.2 0 .65-.55 1.2-1.2 1.2zm3 10c-.66 0-1.2-.55-1.2-1.2 0-.65.55-1.2 1.2-1.2.65 0 1.2.55 1.2 1.2 0 .65-.55 1.2-1.2 1.2zm3-10c-.66 0-1.2-.55-1.2-1.2 0-.65.55-1.2 1.2-1.2.65 0 1.2.55 1.2 1.2 0 .65-.55 1.2-1.2 1.2z"
                  }
                })
              ]
            ),
            _vm._v(" Fork")
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            target: "_blank",
            href: "https://github.com/ujjwalguptaofficial/idbstudio"
          }
        },
        [_c("i", { staticClass: "fas fa-star" }), _vm._v(" Star")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }